import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ModuleComponent } from "../module.component";
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";

@Component({
  templateUrl: "./3C.component.html",
  styleUrls: ["../component.css"]
})


export class _3CComponent extends ModuleComponent {

  C32: string = `Some examples may be your church, the YMCA, a food pantry, a homeless shelter, or other social service agencies.`;

  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "C11",
      "html": `<i class="fas fa-file-import"></i> <strong>Violence</strong> prevention and awareness`
    });
    this.titles.push({
      "activityId": "C12",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Safe at work."`
    });

    this.titles.push({
      "activityId": "C21",
      "html": `<i class="fas fa-file-import"></i> <strong>Continue</strong> to build your skills.`
    });
    this.titles.push({
      "activityId": "C22",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Be ready for your next move."`
    });

    this.titles.push({
      "activityId": "C31",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about the benefits of volunteering.`
    });
    this.titles.push({
      "activityId": "C32",
      "html": `<i class="fas fa-sticky-note"></i><strong>Identify</strong> opportunities to volunteer in your community`
    });
    this.titles.push({
      "activityId": "C33",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Get skills, experience, and network by being a volunteer."`
    });

    this.titles.push({
      "activityId": "C41",
      "html": `<i class="fas fa-file-import"></i> <strong>Test</strong> your knowledge of what you learned. These questions will be on the post-assessment test.`
    });


    this.group = 2;
    this.alpha = "C";

    this.activeMod = { group: 2, alpha: "C", number: 1 };
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    this.loadGuide();
  }
}
